<template>
  <section class="homePage">
    <head-top></head-top>
    <!-- 轮播图 -->
    <swiper class="mod-banner-scroll" :options="bannerSwiperOption">
      <swiper-slide v-for="(item, index) of colorList" :key="index">
        <img :src="item" @click="lunbo(index)" />
      </swiper-slide>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- 如果需要导航按钮 -->
      <div
        class="swiper-button-prev swiper-banner-prev"
        slot="button-prev"
      ></div>
      <div
        class="swiper-button-next swiper-banner-next"
        slot="button-next"
      ></div>
    </swiper>
    <section class="selectKemean">
      <div class="pageCenter">
        <div class="homeTitle black">
          <span>20+营销玩法</span>
          <p>Our Services</p>
        </div>
        <p class="introduction">
          Java语言，覆盖公众号H5、小程序、安卓、IOS
          平台部署，可定制，支持源码二开
        </p>
        <div class="service_box">
          <div class="service_list focus">
            <div class="img">
              <img src="../images/icon_appkaifa.png" />
            </div>
            <div class="info">
              <p>拼团秒杀</p>
              <span>APP Development</span>
            </div>
          </div>
          <div class="service_list">
            <div class="img">
              <img src="../images/icon_wangzhanjianshe.png" />
            </div>
            <div class="info">
              <p>会员等级</p>
            </div>
          </div>
          <div class="service_list">
            <img src="../images/icon_weixinkaifa.png" />
            <div class="info">
              <p>城市代理</p>
            </div>
          </div>
          <div class="service_list focus">
            <div class="img">
              <img src="../images/icon_xiaochengxu.png" />
            </div>
            <div class="info">
              <p>三级分销</p>
              <span>Small Program Development</span>
            </div>
          </div>
          <div class="service_list">
            <img src="../images/icon_yingjiankaifa.png" />
            <div class="info">
              <p>区域代理</p>
            </div>
          </div>
          <div class="service_list">
            <img src="../images/icon_guanlixitong.png" />
            <div class="info">
              <p>电商直播</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="serviceProcessBox">
      <div class="homeTitle">
        <span>服务流程</span>
        <p>service process</p>
      </div>
      <div class="serviceProcess">
        <div class="processList">
          <div class="processIcon process1"></div>
          <div class="processInfo">
            <span>商务沟通</span>
            <p>确定商城系统功能需求</p>
          </div>
        </div>
        <div class="processList">
          <div class="processIcon process2"></div>
          <div class="processInfo">
            <span>确定合作</span>
            <p>在商鼎云商城微定制或者100%复用</p>
          </div>
        </div>
        <div class="processList">
          <div class="processIcon process3"></div>
          <div class="processInfo">
            <span>项目部署</span>
            <p>购买服务器，域名，完整部署</p>
          </div>
        </div>
        <div class="processList">
          <div class="processIcon process4"></div>
          <div class="processInfo">
            <span>项目验收</span>
            <p>验收合同签订商城功能需求</p>
          </div>
        </div>
        <div class="processList">
          <div class="processIcon process5"></div>
          <div class="processInfo">
            <span>项目交付</span>
            <p>交付源码，平台账号，设计稿</p>
          </div>
        </div>
        <div class="processList">
          <div class="processIcon process6"></div>
          <div class="processInfo">
            <span>源码二开</span>
            <p>交付开发手册，部署手册，二开培训</p>
          </div>
        </div>
      </div>
    </section>
    <section class="statisticsBox">
      <div class="homeTitle black">
        <span>公司实力</span>
        <p>Company Strength</p>
      </div>
      <div class="pageCenter">
        <p class="introduction">
          商鼎云技术集团有限公司是最专业的互联网解决方案供应商，汇聚顶尖软件定制开发人才，凭借专业的企业软件定制开发技术、丰富项目经验，为客户提供一站式专业的服务
        </p>
        <div class="progress_box">
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress rightcircle blueStyle"></div>
            </div>
            <div class="wrapper left">
              <div class="circleProgress leftcircle blueStyle"></div>
            </div>
            <div class="txt_box">
              <div class="name">合作客户</div>
              <h2>100+</h2>
            </div>
          </div>
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress rightcircle pupStyle"></div>
            </div>
            <div class="wrapper left">
              <div class="circleProgress leftcircle pupStyle"></div>
            </div>
            <div class="txt_box">
              <div class="name">成功案例</div>
              <h2>180+</h2>
            </div>
          </div>
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress rightcircle redStyle"></div>
            </div>
            <div class="wrapper left">
              <div class="circleProgress leftcircle redStyle"></div>
            </div>
            <div class="txt_box">
              <div class="name">项目成功率</div>
              <h2>99%</h2>
            </div>
          </div>
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress rightcircle yellowStyle"></div>
            </div>
            <div class="wrapper left">
              <div class="circleProgress leftcircle yellowStyle"></div>
            </div>
            <div class="txt_box">
              <div class="name">公司团队</div>
              <h2>50+</h2>
            </div>
          </div>
          <div class="circleProgress_wrapper">
            <div class="wrapper right">
              <div class="circleProgress rightcircle greenStyle"></div>
            </div>
            <div class="wrapper left">
              <div class="circleProgress leftcircle greenStyle"></div>
            </div>
            <div class="txt_box">
              <div class="name">售后服务</div>
              <h2>7*24h</h2>
            </div>
          </div>
        </div>
        <!-- <div class="team_box">
          <div class="team_lists" v-for="(item, index) in 6" :key="index">
            <div class="image_box">
              <img src="../images/icon_jishutuandui.png" />
            </div>
            <div class="name_box">
              <p class="name">技术团队</p>
              <p class="intro">架构设计&代码编写</p>
            </div>
            <div class="disc_box">
              拥有众多的大型项目经验擅长界面绘制与轮机梳理技术外兼备商务独到见解。
            </div>
          </div>
        </div> -->
      </div>
    </section>
    <section class="projectCasesBox">
      <div class="homeTitle">
        <span>电商系统</span>
        <p>Selected Case</p>
      </div>
      <!-- 轮播图 -->
      <div class="casesBox">
        <div
          class="casesList"
          v-for="(item, index) of casesList"
          :key="index"
          @click="detailsJump(item, index)"
        >
          <div
            class="casesImg"
            :class="{ pc: item.casesType == 1101 }"
            :style="{
              backgroundImage:
                'linear-gradient(120deg, ' +
                item.shallowColor +
                ' 0%, ' +
                item.deepColor +
                ' 100%)',
            }"
          >
            <img :src="item.coverImg" />
          </div>
          <div class="casesInfo">
            <h3>{{ item.name }}</h3>
            <p>{{ item.industry }}</p>
          </div>
        </div>
      </div>
      <div class="kemeanBut">
        <button @click="$router.push('/cases')">
          <span>了解更多</span>
        </button>
      </div>
    </section>
    <section class="newsCenterBox">
      <div class="homeTitle black">
        <span>行业资讯</span>
        <p>Industry Information</p>
      </div>
      <div class="banner_and_news pageCenter">
        <div class="banner">
          <swiper
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide
              v-for="(item, index) in articleRecommendList"
              :key="index"
            >
              <z-image
                class="swiper_image"
                v-if="item.headImg"
                :src="item.headImg"
                @click="openJump('/newsDetails?objId=' + item.objId)"
              ></z-image>
            </swiper-slide>
            <div
              class="swiper-button-next swiper-button-white swiper-top-next"
              slot="button-next"
            ></div>
            <div
              class="swiper-button-prev swiper-button-white swiper-top-prev"
              slot="button-prev"
            ></div>
          </swiper>
          <swiper
            :options="swiperOptionThumbs"
            class="gallery-thumbs"
            ref="swiperThumbs"
          >
            <swiper-slide
              v-for="(item, index) in articleRecommendList"
              :key="index"
              >{{ item.title }}</swiper-slide
            >
          </swiper>
        </div>
        <div class="news_list">
          <div
            v-for="(item, index) in articleList"
            :key="index"
            @click="openJump('/newsDetails?objId=' + item.objId)"
          >
            <div class="first" v-if="index === 0">
              <h1>{{ item.title }}</h1>
              <p class="disc">{{ item.introduce }}</p>
            </div>
            <div class="list" v-else>
              <div class="title">{{ item.title }}</div>
              <div class="time">{{ item.createTime }}</div>
            </div>
          </div>
          <button @click="$router.push('/news')">阅读更多 · 最新资讯</button>
        </div>
      </div>
    </section>
    <section class="partnerBox">
      <div class="homeTitle">
        <span>合作伙伴</span>
        <p>Strategic Partners</p>
      </div>
      <div class="partnerListBox">
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/aliWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/qiniuWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/tencentWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/zbjWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/ztkjWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/epwkWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/amerWhite.png" />
        </div>
        <div>
          <img src="https://qn.kemean.cn/upload/201809/06/eankWhite.png" />
        </div>
      </div>
    </section>

    <section class="contactUsBox">
      <div class="homeTitle black">
        <span>联系我们</span>
        <p>CONTACT US</p>
      </div>
      <div class="demandText">
        <span>把您的商城需求告诉我们，3分钟内商务主管联系您</span>
        <p>您的信任是我们最大的动力，商鼎云技术集团有限公司将竭诚为您服务！</p>
      </div>
      <div class="contactInputBox">
        <div class="inputBox">
          <input type="text" placeholder="您的姓名" v-model="name" />
          <input type="text" placeholder="您的电话" v-model="phone" />
          <input type="text" placeholder="您的微信（选填）" v-model="contact" />
        </div>
        <textarea
          placeholder="请描述您的软件需求,3分钟获得项目报价"
          v-model="need"
        ></textarea>
      </div>
      <div class="but">
        <button @click="onSubmit">获取报价</button>
      </div>
    </section>
    <foot-guide></foot-guide>
  </section>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      colorList: [
        "http://qn.kemean.cn/upload/202008/31/c750616443cf4b2996e3dab57887d9be",
        "http://qn.kemean.cn/upload/202103/25/1616658050120xop3hcc0.png",
        "http://qn.kemean.cn/upload/202103/25/22a4995d2566407e8658c9d8de636cd3",
      ],
      bannerSwiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-banner-next",
          prevEl: ".swiper-banner-prev",
        },
      },
      swiperOptionTop: {
        spaceBetween: 10,
        //设置上一页，下一页
        prevButton: ".swiper-top-prev",
        nextButton: ".swiper-top-next",
      },
      swiperOptionThumbs: {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },
      statisticsState: true,
      //数据统计
      statistics1: 10,
      statistics2: 20,
      statistics3: 100,
      statistics4: 200,

      phone: "",
      name: "",
      contact: "",
      need: "",
      casesList: [],
      articleRecommendList: [],
      articleList: [],
    };
  },
  created() {
    this.getPageData();
  },
  methods: {
    //轮播跳转
    lunbo(index) {
      console.log(index);
      this.$router.push("casesDetails/0");
    },
    getPageData() {
      // 获取资讯
      this.$ajax
        .post("api/article/v1/list", {
          pageNo: 1,
          pageSize: 5,
          type: 3003,
        })
        .then((data) => {
          this.articleRecommendList = data.data;
        });
      this.$ajax
        .post("api/article/v1/list", {
          pageNo: 1,
          pageSize: 5,
        })
        .then((data) => {
          this.articleList = data.data;
        });
    },
    onStatistics(index, num, time, regulator) {
      var _this = this;
      var actualTime = time || 1500; //总时间--毫秒为单位
      var actualFinalNum = num || 0; //要显示的真实数值
      var actualRegulator = regulator || 100; //调速器，改变regulator的数值可以调节数字改变的速度
      var step =
        actualFinalNum / (actualTime / actualRegulator); /*每30ms增加的数值--*/
      var count = 0; //计数器
      var initial = 0;
      var timer = setInterval(function () {
        count = count + step;
        if (count >= actualFinalNum) {
          clearInterval(timer);
          count = actualFinalNum;
        }
        //避免调用text函数，提高DOM性能
        var t = Math.floor(count);
        if (t == initial) return;
        initial = t;
        if (index == 1) {
          _this.statistics1 = initial;
        } else if (index == 2) {
          _this.statistics2 = initial;
        } else if (index == 3) {
          _this.statistics3 = initial;
        } else if (index == 4) {
          _this.statistics4 = initial;
        }
      }, 30);
    },
    onSubmit() {
      if (this.name == "") {
        this.prompt("请填写您的称呼");
        return;
      }
      if (this.phone == "") {
        this.prompt("请填写您的手机号，方便我们联系您");
        return;
      }
      if (!/^[1][0-9]{10}$/.test(this.phone)) {
        this.prompt("您填写的手机号格式不正确");
        return;
      }
      let httpData = {
        phone: this.phone,
        nickName: this.name,
        companyName: "商鼎云技术集团有限公司",
      };
      if (this.contact) {
        httpData.wx = this.contact;
      }
      if (this.need) {
        httpData.needDesc = this.need;
      }
      this.$ajax.post("api/user_need/submit", httpData).then(() => {
        this.phone = "";
        this.name = "";
        this.contact = "";
        this.need = "";
        this.$alert("信息已提交，稍后客服会联系您，请保持电话畅通！");
      });
    },
    detailsJump(item, index) {
      if (item.casesType == 1101 || item.casesType == 1501) {
        window.open(item.detailsUrl);
      } else {
        this.$router.push("/casesDetails/" + index);
      }
    },
  },
  beforeDestroy() {
    this.statisticsState = false;
  },
  mounted() {
    var _this = this;
    this.casesList = casesDtata.slice(0, 6);
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      const swiperThumbs = this.$refs.swiperThumbs.swiper;
      swiperTop.controller.control = swiperThumbs;
      swiperThumbs.controller.control = swiperTop;
    });
    // // 接收滚动事件
    // this.$parent.$on("pageScroll", () => {
    //   if (_this.statisticsState) {
    //     var top =
    //       _this.$refs.statistics.offsetTop -
    //       document.documentElement.clientHeight;
    //     var scrollTop =
    //       document.documentElement.scrollTop || document.body.scrollTop;
    //     if (scrollTop >= top) {
    //       _this.onStatistics(1, this.statistics1, 800);
    //       _this.onStatistics(2, _this.statistics2, 1200);
    //       _this.onStatistics(3, _this.statistics3, 1600);
    //       _this.onStatistics(4, _this.statistics4, 2000);
    //       _this.statisticsState = false;
    //     }
    //   }
    // });
  },
};
</script>
<style lang="scss">
@import "src/style/mixin";
@media screen and (min-width: 750px) {
  .homePage {
    .mod-banner-scroll {
      width: 100%;
      height: 30vw;
      .swiper-slide {
        position: relative;
        display: flex;
        justify-content: center;
        width: 100%;
        overflow: hidden;
        img {
          height: 100%;
          width: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 902px;
          max-width: 80vw;
          height: 326px;
          transform: translateX(-50%) translateY(-50%);
          @include bis(
            "https://qn.kemean.cn/upload/201809/06/c791f55979e146f4b66ac9a029fa12ac"
          );
        }
      }
    }
    .selectKemean {
      padding: 100px 0px;
      background-color: #fff;
      h1 {
        text-align: center;
        font-size: 48px;
        color: #444444;
        padding: 0 30px;
        span {
          font-weight: bold;
        }
      }
      .introduction {
        text-align: center;
        font-size: 20px;
        color: #444444;
        margin-top: 30px;
        padding: 0 30px;
      }
      .service_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 60px;
        .service_list {
          width: 25%;
          height: 320px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          min-width: 258px;
          img {
            width: 200px;
            height: 192px;
          }
          .info {
            margin-top: 40px;
            p {
              font-size: 24px;
              color: #333333;
              font-weight: bold;
            }
            span {
              margin-top: 20px;
              font-size: 14px;
              color: #333333;
            }
          }
          &:hover .description {
            display: flex;
          }
          .description {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            align-items: center;
            justify-content: center;
            padding: 15%;
            background-color: rgba(0, 0, 0, 0.6);
            font-size: 18px;
            color: #ffffff;
          }
          &.focus {
            width: 50%;
            min-width: 515px;
            flex-direction: initial;
            .img {
              width: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 260px;
                height: 249px;
              }
            }
            .info {
              width: 50%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              p {
                font-size: 36px;
              }
            }
          }
        }
      }
    }
    .kemeanBut {
      display: flex;
      justify-content: center;
      margin-top: 60px;
      button {
        width: 200px;
        height: 50px;
        background-color: #ffffff;
        box-shadow: 4px 6px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        &:hover::before {
          width: 100%;
        }
        &::before {
          position: absolute;
          content: "";
          top: 0px;
          left: 0px;
          height: 100%;
          width: 0px;
          background: linear-gradient(left, #79c9fc 0%, $mainColor 100%);
          transition: width 0.6s;
        }
        span {
          font-size: 18px;
          color: $mainColor;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }
    }
    //标题
    .homeTitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      &.black {
        span {
          color: #333333;
        }
        p {
          color: rgba(51, 51, 51, 0.5);
        }
      }
      span {
        font-size: 48px;
        color: #ffffff;
      }
      p {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.5);
      }
    }
    .projectCasesBox {
      padding: 6vw 0px;
      background-image: url("https://qn.kemean.cn/upload/201907/15/63a87e071e3f4033a546fe096890a532");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      .casesBox {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        max-width: 1200px;
        margin: 50px auto 0 auto;
        .casesList {
          width: 380px;
          height: 310px;
          border-radius: 10px;
          cursor: pointer;
          margin: 0 10px 30px 10px;
          position: relative;
          .casesImg {
            width: 100%;
            height: 100%;
            background-color: #d7e9f7;
            border-radius: 10px 10px;
            padding: 40px 20px 0 20px;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            overflow: hidden;
            &.pc {
              padding: 40px 60px 0 60px;
            }
            img {
              width: 100%;
              display: block;
            }
          }
          .casesInfo {
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            width: 100%;
            padding: 14px;
            border-radius: 0 0 10px 10px;
            h3 {
              font-size: 18px;
              color: #fff;
            }
            p {
              margin-top: 5px;
              font-size: 14px;
              color: #fff;
            }
          }
        }
      }
    }
    .statisticsBox {
      padding: 6vw 0px 2vw 0px;
      background-color: #fff;
      .introduction {
        margin-top: 50px;
        font-size: 18px;
        color: #333333;
        text-align: center;
        line-height: 180%;
        padding: 0 20px;
      }
      .progress_box {
        margin-top: 60px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .circleProgress_wrapper {
          cursor: pointer;
          width: 180px;
          height: 180px;
          margin: 0 20px;
          position: relative;
          .txt_box {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .name {
              font-size: 18px;
              color: #999999;
            }
            > h2 {
              font-size: 48px;
              color: #333333;
            }
          }
          .wrapper {
            width: 90px;
            height: 180px;
            position: absolute;
            overflow: hidden;
            transform: rotate(90deg);
            &.right {
              top: 45px;
              right: 45px;
            }

            &.left {
              top: -45px;
              left: 45px;
            }
          }

          .circleProgress {
            width: 180px;
            height: 180px;
            border-radius: 50%;
            position: absolute;
            top: 0;
            transform: rotate(45deg);
            &.blueStyle {
              border: 8px solid #4180ff;
            }
            &.pupStyle {
              border: 8px solid #a92fff;
            }
            &.redStyle {
              border: 8px solid #ff3939;
            }
            &.yellowStyle {
              border: 8px solid #ff9833;
            }
            &.greenStyle {
              border: 8px solid #00a4da;
            }
            &.rightcircle {
              border-top: 8px solid #fff;
              border-right: 8px solid #fff;
              right: 0;
              transform: rotate(225deg);
              animation: circleProgressLoad_right 1s linear;
            }

            &.leftcircle {
              border-bottom: 8px solid #fff;
              border-left: 8px solid #fff;
              left: 0;
              transform: rotate(180deg);
              animation: circleProgressLoad_left 1s linear;
            }

            @keyframes circleProgressLoad_right {
              0% {
                transform: rotate(45deg);
              }

              50% {
                transform: rotate(225deg);
              }

              100% {
                transform: rotate(225deg);
              }
            }

            @keyframes circleProgressLoad_left {
              0% {
                transform: rotate(45deg);
              }

              50% {
                transform: rotate(45deg);
              }

              100% {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
      .team_box {
        margin-top: 60px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .team_lists {
          width: 33.33%;
          padding: 26px 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          text-align: center;
          .image_box {
            width: 34px;
            height: 40px;
          }
          .name_box {
            margin-top: 26px;
            .name {
              font-size: 24px;
              color: #333333;
            }
            .intro {
              font-size: 14px;
              color: #999999;
              margin-top: 8px;
            }
          }
          .disc_box {
            margin-top: 26px;
            font-size: 14px;
            color: #333333;
            width: 200px;
          }
        }
      }
    }
    .serviceProcessBox {
      padding: 6vw 0px 2vw 0px;
      background-image: url("https://qn.kemean.cn/upload/201809/06/b42cd46c01b948e89df59959599f5699");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      display: flex;
      align-items: center;
      flex-direction: column;
      .serviceProcess {
        display: flex;
        margin-top: 80px;
        flex-wrap: wrap;
        justify-content: center;
        .processList {
          width: 220px;
          display: flex;
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-bottom: 4vw;
          .processIcon {
            width: 150px;
            height: 150px;
            position: relative;
            &:hover::after {
              transform: rotate(360deg);
            }
            &::after {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 50%;
              background-position: center center;
              background-repeat: no-repeat;
              cursor: pointer;
              transition: all 0.6s;
            }
            &.process1::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/cdd2918dbf58446f94b09255a0c82dad");
            }
            &.process2::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/327943d0d94a4977ae85617e3972c50d");
            }
            &.process3::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/bbbd83a9f29c4998948dc33cf1daa749");
            }
            &.process4::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/f72994b1a4ff4b12a72a538b42ad77d4");
            }
            &.process5::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/5860b432f28d4e988a582a35fde8842a");
            }
            &.process6::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/3c7129d004bb4202b123f15e59f52398");
            }
          }
          .processInfo {
            margin-top: 30px;
            text-align: center;
            span {
              font-size: 24px;
              color: #ffffff;
            }
            p {
              font-size: 16px;
              color: #ffffff;
              padding: 0px 10px;
              text-align: center;
              margin-top: 40px;
            }
          }
        }
      }
    }
    .partnerBox {
      padding: 6vw 0px 6vw 0px;
      background-image: url("https://qn.kemean.cn/upload/201809/06/88b718e45e9543cda6601a79b6d64024");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: cover;
      display: flex;
      flex-direction: column;
      align-items: center;
      .partnerListBox {
        max-width: 1200px;
        margin-top: 60px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        div {
          height: 70px;
          padding: 0px 30px;
          margin-bottom: 20px;
          img {
            height: 100%;
          }
        }
      }
    }

    .contactUsBox {
      padding: 6vw 0px 6vw 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      .demandText {
        margin-top: 3vw;
        text-align: center;
        span {
          font-size: 30px;
          color: $mainColor;
          font-weight: bold;
        }
        p {
          font-size: 18px;
          color: #888888;
          margin-top: 10px;
        }
      }
      .contactInputBox {
        margin-top: 2vw;
        display: flex;
        justify-content: space-between;
        max-width: 1100px;
        width: 80%;
        .inputBox {
          width: 48%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          input {
            width: 100%;
            height: 50px;
            border: solid 2px #808080;
            padding: 0px 20px;
          }
        }
        textarea {
          width: 48%;
          height: 213px;
          border: solid 2px #808080;
          padding: 20px;
          flex-shrink: 0;
        }
      }
      .but {
        max-width: 1100px;
        width: 80%;
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
        button {
          width: 200px;
          height: 50px;
          background-color: $mainColor;
          border-radius: 8px;
          font-size: 18px;
          color: #ffffff;
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .homePage {
    .mod-banner-scroll {
      width: 100%;
      height: 50vw;
      .swiper-slide {
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        span {
          position: absolute;
          top: 50%;
          left: 50%;
          width: 80vw;
          height: 30vw;
          transform: translateX(-50%) translateY(-50%);
          @include bis(
            "https://qn.kemean.cn/upload/201809/06/c791f55979e146f4b66ac9a029fa12ac"
          );
        }
      }
      .swiper-button-prev,
      .swiper-button-next {
        display: none;
      }
    }
    .selectKemean {
      padding: 9vw 0px;
      background-color: #fff;
      h1 {
        text-align: center;
        font-size: 5vw;
        color: #444444;
        padding: 0 3vw;
        span {
          font-weight: bold;
        }
      }
      .introduction {
        text-align: center;
        font-size: 3.6vw;
        color: #444444;
        margin-top: 3vw;
        padding: 0 3vw;
      }
      .service_box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 6vw;
        .service_list {
          width: 50%;
          height: 50vw;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 30vw;
            height: 30vw;
          }
          .info {
            margin-top: 4vw;
            p {
              font-size: 4vw;
              color: #333333;
              font-weight: bold;
            }
            span {
              margin-top: 3vw;
              font-size: 2.6vw;
              color: #333333;
            }
          }
          &:hover .description {
            display: flex;
          }
          .description {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            align-items: center;
            justify-content: center;
            padding: 15%;
            background-color: rgba(0, 0, 0, 0.6);
            font-size: 3.4vw;
            line-height: 180%;
            color: #ffffff;
          }
          &.focus {
            width: 100%;
            flex-direction: initial;
            .img {
              width: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              img {
                width: 36vw;
                height: 36vw;
              }
            }
            .info {
              width: 50%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              p {
                font-size: 4.5vw;
              }
            }
          }
        }
      }
    }
    .kemeanBut {
      display: flex;
      justify-content: center;
      margin-top: 7vw;
      button {
        width: 36vw;
        height: 9vw;
        background-color: #ffffff;
        box-shadow: 4px 6px 8px 0px rgba(0, 0, 0, 0.05);
        border-radius: 1vw;
        font-size: 3.8vw;
        color: #333333;
        cursor: pointer;
      }
    }
    //标题
    .homeTitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      &.black {
        span {
          color: #333333;
        }
        p {
          color: rgba(51, 51, 51, 0.5);
        }
      }
      span {
        font-size: 5vw;
        color: #ffffff;
      }
      p {
        font-size: 2.6vw;
        color: rgba(255, 255, 255, 0.5);
      }
    }
    .projectCasesBox {
      padding: 6vw 3vw;
      background-image: url("https://qn.kemean.cn/upload/201907/15/63a87e071e3f4033a546fe096890a532");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: auto 100%;
      .casesBox {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 5vw auto 0 auto;
        .casesList {
          width: 100%;
          border-radius: 10px;
          cursor: pointer;
          margin-bottom: 3vw;
          position: relative;
          .casesImg {
            width: 100%;
            height: 100%;
            background-color: #d7e9f7;
            border-radius: 10px;
            padding: 8vw 2vw 0 2vw;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            overflow: hidden;
            &.pc {
              padding: 8vw 12vw 0 12vw;
            }
            img {
              width: 100%;
              display: block;
            }
          }
          .casesInfo {
            position: absolute;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.5);
            border-radius: 0px 0px 10px 10px;
            padding: 2vw 3vw;
            width: 100%;
            h3 {
              font-size: 4vw;
              color: #fff;
            }
            p {
              margin-top: 5px;
              font-size: 3.2vw;
              color: #fff;
            }
          }
        }
      }
    }
    .statisticsBox {
      padding: 6vw 0px 2vw 0px;
      background-color: #fff;
      .introduction {
        margin-top: 5vw;
        font-size: 3.2vw;
        color: #333333;
        text-align: center;
        line-height: 180%;
        padding: 0 3.2vw;
      }
      .progress_box {
        margin-top: 6vw;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .circleProgress_wrapper {
          cursor: pointer;
          width: 28vw;
          height: 28vw;
          margin: 0 2vw;
          position: relative;
          .txt_box {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .name {
              font-size: 3.2vw;
              color: #999999;
            }
            > h2 {
              font-size: 5vw;
              color: #333333;
            }
          }
          .wrapper {
            width: 14vw;
            height: 28vw;
            position: absolute;
            overflow: hidden;
            transform: rotate(90deg);
            &.right {
              top: 7vw;
              right: 7vw;
            }

            &.left {
              top: -7vw;
              left: 7vw;
            }
          }

          .circleProgress {
            width: 28vw;
            height: 28vw;
            border-radius: 50%;
            position: absolute;
            top: 0;
            transform: rotate(45deg);
            &.blueStyle {
              border: 8px solid #4180ff;
            }
            &.pupStyle {
              border: 8px solid #a92fff;
            }
            &.redStyle {
              border: 8px solid #ff3939;
            }
            &.yellowStyle {
              border: 8px solid #ff9833;
            }
            &.greenStyle {
              border: 8px solid #00a4da;
            }
            &.rightcircle {
              border-top: 8px solid #fff;
              border-right: 8px solid #fff;
              right: 0;
              transform: rotate(225deg);
              animation: circleProgressLoad_right 1s linear;
            }

            &.leftcircle {
              border-bottom: 8px solid #fff;
              border-left: 8px solid #fff;
              left: 0;
              transform: rotate(180deg);
              animation: circleProgressLoad_left 1s linear;
            }

            @keyframes circleProgressLoad_right {
              0% {
                transform: rotate(45deg);
              }

              50% {
                transform: rotate(225deg);
              }

              100% {
                transform: rotate(225deg);
              }
            }

            @keyframes circleProgressLoad_left {
              0% {
                transform: rotate(45deg);
              }

              50% {
                transform: rotate(45deg);
              }

              100% {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
      .team_box {
        margin-top: 6vw;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .team_lists {
          width: 50%;
          padding: 3vw 0;
          display: flex;
          align-items: center;
          flex-direction: column;
          text-align: center;
          .image_box {
            width: 8vw;
            height: 8vw;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .name_box {
            margin-top: 2vw;
            .name {
              font-size: 3.2vw;
              color: #333333;
            }
            .intro {
              font-size: 3vw;
              color: #999999;
              margin-top: 0.8vw;
            }
          }
          .disc_box {
            margin-top: 3vw;
            font-size: 2.6vw;
            color: #333333;
            width: 80%;
            line-height: 180%;
          }
        }
      }
    }
    .serviceProcessBox {
      padding: 6vw 0px 2vw 0px;
      background-image: url("https://qn.kemean.cn/upload/201809/06/b42cd46c01b948e89df59959599f5699");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: auto 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      .serviceProcess {
        margin-top: 8vw;
        .processList {
          display: flex;
          align-items: center;
          margin-bottom: 4vw;
          padding: 0px 7vw;
          .processIcon {
            width: 26vw;
            height: 26vw;
            position: relative;
            flex-shrink: 0;
            margin-right: 4vw;
            &:hover::after {
              transform: rotate(360deg);
            }
            &::after {
              content: "";
              width: 100%;
              height: 100%;
              position: absolute;
              background-color: rgba(0, 0, 0, 0.7);
              border-radius: 50%;
              background-position: center center;
              background-repeat: no-repeat;
              background-size: 50% auto;
              cursor: pointer;
              transition: all 0.6s;
            }
            &.process1::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/cdd2918dbf58446f94b09255a0c82dad");
            }
            &.process2::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/327943d0d94a4977ae85617e3972c50d");
            }
            &.process3::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/bbbd83a9f29c4998948dc33cf1daa749");
            }
            &.process4::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/f72994b1a4ff4b12a72a538b42ad77d4");
            }
            &.process5::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/5860b432f28d4e988a582a35fde8842a");
            }
            &.process6::after {
              background-image: url("https://qn.kemean.cn/upload/201809/06/3c7129d004bb4202b123f15e59f52398");
            }
          }
          .processInfo {
            span {
              font-size: 5vw;
              color: #ffffff;
            }
            p {
              font-size: 3.6vw;
              color: #ffffff;
              margin-top: 3vw;
            }
          }
        }
      }
    }
    .partnerBox {
      padding: 6vw 0px 6vw 0px;
      background-image: url("https://qn.kemean.cn/upload/201809/06/88b718e45e9543cda6601a79b6d64024");
      background-position: center bottom;
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-size: auto 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .partnerListBox {
        margin-top: 6vw;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding: 0px 1vw;
        div {
          padding: 0px 1.5vw;
          margin-bottom: 2vw;
          height: 15vw;
          img {
            height: 100%;
          }
        }
      }
    }
    .newsCenterBox {
      padding: 6vw 0px 6vw 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      .banner_and_news {
        margin-top: 3vw;
        .banner {
          width: 100%;
          height: 40vw;
          overflow: hidden;
          .gallery-top {
            cursor: pointer;
            width: 100%;
            height: 34vw;
            .swiper_image {
              width: 100%;
              height: 34vw;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .gallery-thumbs {
            width: 100%;
            cursor: pointer;
            background-color: #000;
            height: 6vw;
            .swiper-slide {
              width: 30vw;
              height: 6vw;
              text-align: center;
              line-height: 6vw;
              background-color: #000;
              color: #fff;
              @include toe();
              font-size: 3.2vw;
            }
            .swiper-slide-active {
              background-color: #4180ff;
              color: #fff;
            }
          }
        }
        .news_list {
          width: 100%;
          margin-top: 3vw;
          .first {
            margin-bottom: 2vw;
            cursor: pointer;
            h1 {
              font-size: 4vw;
              color: #333333;
              margin-bottom: 2vw;
            }
            .disc {
              font-size: 2.6vw;
              color: #333333;
              @include bov();
            }
          }
          .list {
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0;
            border-top: 1px solid #e5e5e5;
            width: 100%;
            .title {
              font-size: 2.4vw;
              color: #333333;
              width: calc(100% - 3vw);
              @include toe();
            }
            .time {
              flex-shrink: 0;
              font-size: 2vw;
              color: #999999;
            }
          }
          > button {
            width: 100%;
            height: 6vw;
            line-height: 6vw;
            color: #fff;
            font-size: 2.2vw;
            text-align: center;
            background-color: #333333;
          }
        }
      }
    }
    .contactUsBox {
      padding: 6vw 0px 6vw 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      .demandText {
        margin-top: 5vw;
        text-align: center;
        padding: 0px 2vw;
        span {
          font-size: 4.2vw;
          color: $mainColor;
          font-weight: bold;
        }
        p {
          font-size: 3.4vw;
          color: #888888;
          margin-top: 2vw;
        }
      }
      .contactInputBox {
        margin-top: 6vw;
        width: 100%;
        padding: 0px 3vw;
        .inputBox {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          input {
            width: 100%;
            height: 12vw;
            border: solid 2px #808080;
            padding: 0px 2vw;
            margin-bottom: 3vw;
          }
        }
        textarea {
          width: 100%;
          height: 40vw;
          border: solid 2px #808080;
          padding: 2vw;
          flex-shrink: 0;
        }
      }
      .but {
        display: flex;
        justify-content: center;
        margin-top: 4vw;
        button {
          width: 34vw;
          height: 10vw;
          background-color: $mainColor;
          border-radius: 1vw;
          font-size: 3.8vw;
          color: #ffffff;
        }
      }
    }
  }
}

@media screen and (min-width: 1100px) {
  .newsCenterBox {
    padding: 6vw 0px 6vw 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .banner_and_news {
      margin-top: 50px;
      display: flex;
      justify-content: space-between;
      .banner {
        width: 60%;
        min-width: 610px;
        height: 380px;
        overflow: hidden;
        .gallery-top {
          cursor: pointer;
          width: 100%;
          height: 340px;

          .swiper_image {
            width: 100%;
            height: 340px;
          }
        }
        .gallery-thumbs {
          cursor: pointer;
          background-color: #000;
          height: 40px;
          .swiper-slide {
            width: 164px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-color: #000;
            color: #fff;
            @include toe();
          }
          .swiper-slide-active {
            background-color: #4180ff;
            color: #fff;
          }
        }
      }
      .news_list {
        width: 40%;
        min-width: 360px;
        padding-left: 40px;
        .first {
          margin-bottom: 20px;
          cursor: pointer;
          h1 {
            font-size: 24px;
            color: #333333;
            margin-bottom: 20px;
          }
          .disc {
            font-size: 14px;
            color: #333333;
            @include bov();
          }
        }

        .list {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          border-top: 1px solid #e5e5e5;
          width: 100%;
          .title {
            font-size: 14px;
            color: #333333;
            width: calc(100% - 80px);
            @include toe();
          }
          .time {
            flex-shrink: 0;
            font-size: 12px;
            color: #999999;
          }
        }
        > button {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #fff;
          font-size: 14px;
          text-align: center;
          background-color: #333333;
        }
      }
    }
  }
}
@media screen and (min-width: 750px) and (max-width: 1100px) {
  .newsCenterBox {
    padding: 6vw 0px 6vw 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    .banner_and_news {
      margin-top: 40px;
      .banner {
        width: 100%;
        height: 380px;
        overflow: hidden;
        .gallery-top {
          cursor: pointer;
          width: 100%;
          height: 340px;
          .swiper_image {
            width: 100%;
            height: 340px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .gallery-thumbs {
          width: 100%;
          cursor: pointer;
          background-color: #000;
          height: 40px;
          .swiper-slide {
            width: 164px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background-color: #000;
            color: #fff;
            @include toe();
          }
          .swiper-slide-active {
            background-color: #4180ff;
            color: #fff;
          }
        }
      }
      .news_list {
        width: 100%;
        margin-top: 30px;
        .first {
          margin-bottom: 20px;
          cursor: pointer;
          h1 {
            font-size: 24px;
            color: #333333;
            margin-bottom: 20px;
          }
          .disc {
            font-size: 14px;
            color: #333333;
            @include bov();
          }
        }
        .list {
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 0;
          border-top: 1px solid #e5e5e5;
          width: 100%;
          .title {
            font-size: 14px;
            color: #333333;
            width: calc(100% - 80px);
            @include toe();
          }
          .time {
            flex-shrink: 0;
            font-size: 12px;
            color: #999999;
          }
        }
        > button {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #fff;
          font-size: 14px;
          text-align: center;
          background-color: #333333;
        }
      }
    }
  }
}
</style>
